export const _en = {
    create: {
        success: {
            title: "Creation done"
        },
        error: {
            title: "Creation failure"
        }
    },
    update: {
        success: {
            title: "Edition done"
        },
        error: {
            title: "Edition failure"
        }
    },
    delete: {
        success: {
            title: "Deletion done"
        },
        error: {
            title: "Deletion failure"
        }
    },
    archive: {
        success: {
            title: "Archiving done"
        },
        error: {
            title: "Archiving failure"
        }

    },
    warning: {
        title: "warning"
    },
    error: {
        title: "Error"
    },
    info: {
        title: "Information"
    }
};

export const _fr = {
    create: {
        success: {
            title: "Création réussie"
        },
        error: {
            title: "Échec de la création"
        }
    },
    update: {
        success: {
            title: "Mise à jour réussie"
        },
        error: {
            title: "Échec de la mise à jour"
        }
    },
    delete: {
        success: {
            title: "Suppression réussie"
        },
        error: {
            title: "Échec de la suppression"
        }
    },
    archive: {
        success: {
            title: "Archivage réussi"
        },
        error: {
            title: "Échec de l'archivage"
        }

    },
    warning: {
        title: "Attention"
    },
    error: {
        title: "Erreur"
    },
    info: {
        title: "Information"
    }
};